import { render, staticRenderFns } from "./binding1.vue?vue&type=template&id=6cad6724&scoped=true&"
import script from "./binding1.vue?vue&type=script&lang=js&"
export * from "./binding1.vue?vue&type=script&lang=js&"
import style0 from "./binding1.vue?vue&type=style&index=0&id=6cad6724&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cad6724",
  null
  
)

export default component.exports